/**
 *   Разрешение пуш уведомлений

     PwaPush.addCallbacks({
        init: () => {...},
        enabled: (text) => {...},
        disabled: (text) => {...},
        computing: (text) => {...},
        incompatible: (text) => {...},
        error: (text) => {...},
    });

 **/

class PwaPush {
    constructor() {
        this.isPushEnabled = false;
        this.callbacks = [];
        this.pwaPush = $('#pwapush');

        if(!this.pwaPush) return;
        this.applicationServerKey = this.pwaPush.attr('data-push-key');
        this.pushSubscribeUrl = this.pwaPush.attr('data-push-subscribe');

        this.init();
        this.initSendTestPush();
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {

            if (!('serviceWorker' in navigator)) {
                console.warn('Service workers are not supported by this browser');
                this.changePushButtonState('incompatible');
                return;
            }

            if (!('PushManager' in window)) {
                console.warn('Push notifications are not supported by this browser');
                this.changePushButtonState('incompatible');
                return;
            }

            if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
                console.warn('Notifications are not supported by this browser');
                this.changePushButtonState('incompatible');
                return;
            }

            // Check the current Notification permission.
            // If its denied, the button should appears as such, until the user changes the permission manually
            if (Notification.permission === 'denied') {
                console.warn('Notifications are denied by the user');
                this.changePushButtonState('incompatible');
                return;
            }

            navigator.serviceWorker.ready.then(
                () => {
                    this.updateSubscription();
                    this.callbacks.forEach((el) => el.init && el.init());
                },
                () => {
                    this.changePushButtonState('incompatible');
                }
            );
        });
    }

    initSendTestPush() {
        /**
         * send_push_notification
         * this part handles the button that calls the endpoint that triggers a notification
         * in the real world, you wouldn't need this, because notifications are typically sent from backend logic
         */

        const sendPushButton = document.querySelector('#send-push-button');

        if (sendPushButton) {
            sendPushButton.addEventListener('click', () =>
                navigator.serviceWorker.ready
                    .then(serviceWorkerRegistration => serviceWorkerRegistration.pushManager.getSubscription())
                    .then(subscription => {
                        if (!subscription) {
                            alert('Please enable push notifications');
                            return;
                        }

                        const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0];
                        const jsonSubscription = subscription.toJSON();
                        fetch('/temp/web-push-php-example/src/send_push_notification.php', {
                            method: 'POST',
                            body: JSON.stringify(Object.assign(jsonSubscription, {contentEncoding})),
                        });
                    })
            );
        }
    }

    changePushButtonState(state) {
        switch (state) {
            case 'enabled':
                this.isPushEnabled = true;
                this.callbacks.forEach((el) => el.enabled && el.enabled('Отключить пуш уведомления'));
                break;
            case 'disabled':
                this.isPushEnabled = false;
                this.callbacks.forEach((el) => el.disabled && el.disabled('Включить пуш уведомления'));
                break;
            case 'computing':
                this.callbacks.forEach((el) => el.computing && el.computing('Загрузка...'));
                break;
            case 'incompatible':
                this.callbacks.forEach((el) => el.incompatible && el.incompatible('Пуш уведомления не совместимы с данным браузером либо отключены'));
                break;
            default:
                console.error('Unhandled push button state', state);
                this.callbacks.forEach((el) => el.error && el.error('Unhandled push button state'));
                break;
        }
    }

    urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    checkNotificationPermission() {
        return new Promise((resolve, reject) => {
            if (Notification.permission === 'denied') {
                return reject(new Error('Push messages are blocked.'));
            }

            if (Notification.permission === 'granted') {
                return resolve();
            }

            if (Notification.permission === 'default') {
                return Notification.requestPermission().then(result => {
                    if (result !== 'granted') {
                        reject(new Error('Bad permission result'));
                    } else {
                        resolve();
                    }
                });
            }

            return reject(new Error('Unknown permission'));
        });
    }

    subscribe() {
        this.changePushButtonState('computing');

        return this.checkNotificationPermission()
            .then(() => navigator.serviceWorker.ready)
            .then(serviceWorkerRegistration =>
                serviceWorkerRegistration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: this.urlBase64ToUint8Array(this.applicationServerKey),
                })
            )
            .then(subscription => {
                // Subscription was successful
                // create subscription on your server
                return this.sendSubscriptionToServer(subscription, 'POST');
            })
            .then(subscription => subscription && this.changePushButtonState('enabled')) // update your UI
            .catch(e => {
                if (Notification.permission === 'denied') {
                    // The user denied the notification permission which
                    // means we failed to subscribe and the user will need
                    // to manually change the notification permission to
                    // subscribe to push messages
                    console.warn('Notifications are denied by the user.');
                    this.changePushButtonState('incompatible');
                } else {
                    // A problem occurred with the subscription; common reasons
                    // include network errors or the user skipped the permission
                    console.error('Impossible to subscribe to push notifications', e);
                    this.changePushButtonState('disabled');
                }
            });
    }

    updateSubscription() {
        navigator.serviceWorker.ready
            .then(serviceWorkerRegistration => serviceWorkerRegistration.pushManager.getSubscription())
            .then(subscription => {
                this.changePushButtonState('disabled');

                if (!subscription) {
                    // We aren't subscribed to push, so set UI to allow the user to enable push
                    return;
                }

                // Keep your server in sync with the latest endpoint
                return this.sendSubscriptionToServer(subscription, 'PUT');
            })
            .then(subscription => subscription && this.changePushButtonState('enabled')) // Set your UI to show they have subscribed for push messages
            .catch(e => {
                console.error('Error when updating the subscription', e);
                this.callbacks.forEach((el) => el.error && el.error('Error when updating the subscription'));
            });
    }

    unsubscribe() {
        this.changePushButtonState('computing');

        // To unsubscribe from push messaging, you need to get the subscription object
        navigator.serviceWorker.ready
            .then(serviceWorkerRegistration => serviceWorkerRegistration.pushManager.getSubscription())
            .then(subscription => {
                // Check that we have a subscription to unsubscribe
                if (!subscription) {
                    // No subscription object, so set the state
                    // to allow the user to subscribe to push
                    this.changePushButtonState('disabled');
                    return;
                }

                // We have a subscription, unsubscribe
                // Remove push subscription from server
                return this.sendSubscriptionToServer(subscription, 'DELETE');
            })
            .then(subscription => subscription.unsubscribe())
            .then(() => this.changePushButtonState('disabled'))
            .catch(e => {
                // We failed to unsubscribe, this can lead to
                // an unusual state, so  it may be best to remove
                // the users data from your data store and
                // inform the user that you have done so
                console.error('Error when unsubscribing the user', e);
                this.changePushButtonState('disabled');
            });
    }

    sendSubscriptionToServer(subscription, method) {
        const key = subscription.getKey('p256dh');
        const token = subscription.getKey('auth');
        const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0];

        return fetch(this.pushSubscribeUrl, {
            method,
            body: JSON.stringify({
                endpoint: subscription.endpoint,
                publicKey: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
                authToken: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
                contentEncoding,
            }),
        }).then(() => subscription);
    }

    addCallbacks(callbacks) {
        this.callbacks.push(callbacks);
    }
}

export default new PwaPush();
